import { i18nextContainer } from 'shared/configs/i18n/config'

import { minItemNameLength } from '../constants'

export function validateItemName(name: string) {
  const trimmed = name.trim()

  let error:
    | 'invalid-name'
    | 'name-too-short'
    | 'invalid-characters'
    | 'reserved-name'
    | 'trailing-issue'
    | undefined = undefined

  if (!trimmed) {
    error = 'invalid-name'
  } else if (trimmed.length < minItemNameLength) {
    error = 'name-too-short'
  } else if (/[\\/:*?"<>|\0]/.test(trimmed)) {
    error = 'invalid-characters'
  } else if (/^(con|prn|aux|nul|com[1-9]|lpt[1-9])(\..*)?$/i.test(trimmed)) {
    error = 'reserved-name'
  } else if (/[\s.]$/.test(trimmed)) {
    error = 'trailing-issue'
  }

  return error
    ? {
        title: i18nextContainer.t(`desktop.item-name-errors.${error}.title`),
        subTitle: i18nextContainer.t(
          `desktop.item-name-errors.${error}.subtitle`,
          error === 'name-too-short'
            ? {
                min: minItemNameLength
              }
            : undefined
        )
      }
    : undefined
}
